// extracted by mini-css-extract-plugin
export default {"container":"ConvincingItem_container__MHMml","itemIcon":"ConvincingItem_itemIcon__qICwm","convincingText":"ConvincingItem_convincingText__5U2Yw"};